"use strict";

import React from 'react';

const SvgExpandIcon = ({className='', color='',size='16'}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 72 72">
            <g>
                <path className={className} fill={color}  d="M29.7,27c0.1-0.1,0.1-0.4,0-0.5l-7.1-7.1c-0.1-0.1-0.1-0.4,0-0.5l5.3-5.3c0.1-0.1,0.1-0.2-0.1-0.2H13.4
		c-0.2,0-0.4,0.2-0.4,0.4V28c0,0.2,0.1,0.2,0.2,0.1l5.2-5.2c0.1-0.1,0.4-0.1,0.5,0l7.1,7.1c0.1,0.1,0.4,0.1,0.5,0L29.7,27z"/>
            </g>
            <g>
                <path className={className} fill={color}  d="M42.5,27c-0.1-0.1-0.1-0.4,0-0.5l7.1-7.1c0.1-0.1,0.1-0.4,0-0.5l-5.3-5.3c-0.1-0.1-0.1-0.2,0.1-0.2h14.3
		c0.2,0,0.3,0.2,0.3,0.4V28c0,0.2-0.1,0.2-0.2,0.1l-5.2-5.2c-0.1-0.1-0.4-0.1-0.5,0L46,30c-0.1,0.1-0.4,0.1-0.5,0L42.5,27z"/>
            </g>
            <g>
                <path className={className} fill={color}  d="M29.7,45.8c0.1,0.1,0.1,0.4,0,0.5l-7.1,7.1c-0.1,0.1-0.1,0.4,0,0.5l5.3,5.3c0.1,0.1,0.1,0.2-0.1,0.2H13.4
		c-0.2,0-0.4-0.2-0.4-0.3V44.7c0-0.2,0.1-0.2,0.2-0.1l5.2,5.2c0.1,0.1,0.4,0.1,0.5,0l7.1-7.1c0.1-0.1,0.4-0.1,0.5,0L29.7,45.8z"/>
            </g>
            <g>
                <path className={className} fill={color}  d="M42.5,45.8c-0.1,0.1-0.1,0.4,0,0.5l7.1,7.1c0.1,0.1,0.1,0.4,0,0.5l-5.3,5.3c-0.1,0.1-0.1,0.2,0.1,0.2h14.3
		c0.2,0,0.3-0.2,0.3-0.3V44.7c0-0.2-0.1-0.2-0.2-0.1l-5.2,5.2c-0.1,0.1-0.4,0.1-0.5,0L46,42.8c-0.1-0.1-0.4-0.1-0.5,0L42.5,45.8z"/>
            </g>
        </svg>
    );
};

export default SvgExpandIcon;
